import Link from "next/link";
import styles from "./Brand.module.css";

type BrandProps = {
  onClick?: () => void;
};

export function Brand({ onClick }: BrandProps) {
  return (
    <Link className={styles.brand} href="/tasks" onClick={onClick} aria-label="TradingPlatform tasks">
      <span className={styles.mark} aria-hidden="true">
        <span />
        <span />
        <span />
      </span>
      <span className={styles.wordmark}>
        Trading<strong>Platform</strong>
      </span>
    </Link>
  );
}
